import * as React from "react"
import {Link} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import {batch} from "@preact/signals-react";

import {usePriceDiscountCandlestickModal} from "../@hooks";


export default function PricingCandlestickDetailsButton({ discount, groupedID, externalSeller, onCloseTooltip }) {
    const { handleSubmit } = usePriceDiscountCandlestickModal(discount, groupedID, externalSeller)

    const handleClick = () => batch(() => {
        onCloseTooltip()
        handleSubmit()
    })

    return <Link onClick={handleClick} color="info.main" sx={{ fontWeight: 'normal', textDecoration: 'underline', cursor: 'pointer' }}>
        Product Details <IconSeeker icon="chevron-right" />
    </Link>
}